import type { SVGProps } from 'react';

const SvgLineVideoPlay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={17}
    viewBox='0 0 16 17'
    width={16}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10.001 1.213c1.716 0 3.047.34 3.937 1.23s1.229 2.221 1.229 3.937v4c0 1.716-.34 3.047-1.23 3.937s-2.22 1.23-3.936 1.23h-4c-1.716 0-3.048-.34-3.938-1.23-.889-.89-1.229-2.221-1.229-3.937v-4c0-1.716.34-3.048 1.23-3.937.89-.89 2.221-1.23 3.937-1.23zM1.862 5.62q-.027.355-.028.76v4c0 1.617.326 2.62.937 3.23.61.61 1.613.936 3.23.936h4c1.617 0 2.62-.326 3.23-.936s.936-1.613.936-3.23v-4q0-.405-.028-.76zm4.862 2.117c.5-.29 1.104-.2 1.64.11l.693.4.693.4.193.125c.432.307.722.736.722 1.24 0 .579-.378 1.057-.914 1.367l-1.388.8c-.537.31-1.139.4-1.64.111S6 11.433 6 10.813v-1.6c0-.62.224-1.187.724-1.476m1.14.976c-.35-.202-.555-.16-.64-.111S7 8.807 7 9.213v1.6c0 .406.14.562.225.611s.288.093.638-.11l1.386-.8.12-.076c.246-.175.296-.339.296-.425 0-.1-.066-.298-.416-.5zM5.18 2.245c-1.147.096-1.91.405-2.41.905-.348.348-.603.825-.758 1.47H5.18zm1 2.375h3.64V2.213H6.18zm4.64 0h3.17c-.156-.645-.411-1.122-.76-1.47-.5-.5-1.262-.809-2.41-.905z'
      fill='#3889FF'
    />
  </svg>
);
export default SvgLineVideoPlay;
